module.exports = __webpack_public_path__ + "img/56e4bd509c299b4724f6dfc58237bd57ad7e1b58.143646dd.png";